const token = ( state=null , action) => {
    switch (action.type) {
        case 'TOKEN' :
            return {
                token : action.token,
            }
        default :
            return state;
    }
};


export default token;